function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import getRoleProperty from '../getRoleProperty';
import _ from 'lodash';

var ContactRoleWCLaborClientCtrl = function ContactRoleWCLaborClientCtrl() {
    var _this = this;

    _classCallCheck(this, ContactRoleWCLaborClientCtrl);

    this.$onInit = function () {
        var _getRoleProperty = getRoleProperty(_this.roleType, _this.roleModel, 'laborClient', 'wCLaborContact'),
            fieldGetter = _getRoleProperty.fieldGetter;

        var details = fieldGetter(undefined, 'laborContactDetails.children') || [];

        _this.laborClientDetails = details.map(function (detail) {
            return {
                inclusion: _.get(detail, 'inclusion.value.name'),
                state: _.get(detail, 'state.value.name'),
                contractEffectiveDate: _.get(detail, 'contractEffectiveDate.value'),
                contractExpirationDate: _.get(detail, 'contractExpirationDate.value'),
                descriptionOfDuties: _.get(detail, 'descriptionOfDuties.value'),
                workLocation: _.get(detail, 'workLocation'),
                numberOfEmployees: _.get(detail, 'numberOfEmployees')
            };
        });
    };
};

export default ContactRoleWCLaborClientCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/roles/ContactRoleLaborClient/ContactRoleLaborClientCtrl.js
// module id = 1646
// module chunks = 0